define(["angular", "../sanitize/sanitize"], function (angular) {
    "use strict";

    return angular.module("entityDTOModule", [
        "sanitizeModule"
    ]);
});

